import { useState, useEffect } from "react";
import {
  ModelDefinition,
  UndefinedModelDefinition,
} from "@pureweb/platform-sdk";
import { ModelService } from "../services/ModelService";
import { ClientOptions } from "../types";
import logger from "../Log";
import { useCallback } from "react";

export const useModelManager = (clientOptions: ClientOptions) => {
  const [modelDefinitionUnavailable, setModelDefinitionUnavailable] =
    useState(false);
  const [modelDefinition, setModelDefinition] = useState(
    new UndefinedModelDefinition()
  );
  const [availableModels, setAvailableModels] = useState<ModelDefinition[]>();

  useEffect(() => {
    if (availableModels?.length) {
      const selectedModel = ModelService.findSelectedModel(
        availableModels,
        clientOptions
      );

      if (selectedModel) {
        setModelDefinition(selectedModel);
      } else {
        setModelDefinitionUnavailable(true);
      }
    }
  }, [availableModels, clientOptions]);

  const initializeModels = useCallback(
    async (platform: any) => {
      try {
        const models = await ModelService.initializeModels(
          platform,
          clientOptions
        );
        setAvailableModels(models);
      } catch (err) {
        logger.error(err);
      }
    },
    [clientOptions]
  );

  return {
    modelDefinitionUnavailable,
    modelDefinition,
    availableModels,
    initializeModels,
  };
};
